import { useEffect } from 'react';
import { TreeSelect } from 'antd';
import { createElement } from 'react';
import { useSetState } from 'ahooks';
import './index.css';
;
;
const ApplyTreeSelect = function ApplyTreeSelect(props) {
    const { selNode = () => {
        console.log('empty selNode func');
    } } = props;
    const [state, setState] = useSetState({
        loadingData: false,
        treeData: [],
        expandedKeys: [],
        loadedKeys: [],
        biz1List: [],
        biz2List: [],
        selectedKeys: ['root'],
        openKeys: '',
    });
    const getDefaultKeys = (data, appId) => {
        if (Array.isArray(data)) {
            data.forEach((item) => {
                getDefaultKeys(item, appId);
            });
        }
        if (data.children) {
            data.children.forEach((item) => {
                getDefaultKeys(item, appId);
            });
        }
        else if (data?.appFlagId && data?.appFlagId === appId) {
            setState({
                openKeys: data?.businessId,
            });
        }
        return;
    };
    const getTreeData = () => {
        setState({
            loadingData: true,
        });
        try {
            fetch('/devops-appcmdb-service/api/v1/business/list-tree').then(async (response) => {
                setState({
                    loadingData: false,
                });
                if (response.status === 200) {
                    const res = await response.json();
                    const data = Array.isArray(res.data) && res.data.map((item) => {
                        return {
                            ...item,
                            children: item.appList,
                        };
                    });
                    getDefaultKeys(data, props.defaultAppId);
                    setState({
                        treeData: [{
                                title: '应用树',
                                treeType: 'root',
                                key: 'root',
                                id: 'root',
                                children: data,
                            }],
                        expandedKeys: ['root', state.openKeys || props.defaultAppId],
                        loadedKeys: ['root'],
                    });
                }
                else {
                    alert(response?.message || '请求错误');
                }
            });
        }
        catch (err) {
            console.log(err);
        }
    };
    const selectNode = (selectedKeys) => {
        selNode(selectedKeys);
    };
    const onExpand = (expandedKeys) => {
        setState({
            expandedKeys,
        });
    };
    const renderTreeNodes = (data) => data.map((item) => {
        if (item.children) {
            return (createElement(TreeSelect.TreeNode, { title: item.name, key: item.appFlagId, isLeaf: false, value: item.id, selectable: false, dataRef: item, ...item }, renderTreeNodes(item.children)));
        }
        return createElement(TreeSelect.TreeNode, { title: item.name, key: item.appFlagId, isLeaf: true, value: item.appFlagId, selectable: item.isLeaf, dataRef: item, ...item });
    });
    useEffect(() => {
        getTreeData();
    }, []);
    return (createElement(TreeSelect, { style: { width: '100%' }, treeLoadedKeys: state.loadedKeys, onTreeExpand: onExpand, onSelect: selectNode, treeLine: true, disabled: props?.disabled || false, treeDefaultExpandedKeys: state.expandedKeys, defaultValue: props.defaultAppId, allowClear: true }, renderTreeNodes(state.treeData)));
};
export default ApplyTreeSelect;
